import api from './api';

export interface NotificationDto {
  uniqueid: string;
  ruleId: number;
  maloaitb: number;
  tenLoaiTb: string;
  makcb: string | null;
  manv: string | null;
  makk: number | null;
  mamucdo: number;
  tenMucDo: string;
  colorCode: string;
  noidung: string | null;
  ngay: string | null;
  systemtime: string | null;
  active: number;
  tendichvu: string | null;
  manhom: number | null;
  ngaykt: string | null;
}

export interface FilterOption {
  value: string | number;
  label: string;
}

export interface RunRulesByLoaiTbRequestDto {
  maloaitb: number;
}

export interface RunRulesByLoaiTbResponseDto {
  success: boolean;
  rulesCount: number;
  totalRowsReturned: number;
  totalNotificationsInserted: number;
  message: string;
}

export const notificationsService = {
  async getAll(): Promise<NotificationDto[]> {
    const res = await api.get('/notifications');
    return (res.data || []).map((r: any) => ({
      uniqueid: r.uniqueid ?? r.Uniqueid,
      ruleId: r.ruleId ?? r.RuleId,
      maloaitb: r.maloaitb ?? r.Maloaitb,
      tenLoaiTb: r.tenLoaiTb ?? r.TenLoaiTb,
      makcb: r.makcb ?? r.Makcb,
      manv: r.manv ?? r.Manv,
      makk: r.makk ?? r.Makk,
      mamucdo: r.mamucdo ?? r.Mamucdo,
      tenMucDo: r.tenMucDo ?? r.TenMucDo,
      colorCode: r.colorCode ?? r.ColorCode,
      noidung: r.noidung ?? r.Noidung,
      ngay: r.ngay ?? r.Ngay,
      systemtime: r.systemtime ?? r.Systemtime,
      active: r.active ?? r.Active,
      tendichvu: r.tendichvu ?? r.Tendichvu,
      manhom: r.manhom != null ? Number(r.manhom) : (r.Manhom != null ? Number(r.Manhom) : null),
      ngaykt: r.ngaykt ?? r.Ngaykt
    }));
  },

  async getByLoaiTb(maloaitb: number): Promise<NotificationDto[]> {
    const res = await api.get(`/notifications/by-loaitb/${maloaitb}`);
    return (res.data || []).map((r: any) => ({
      uniqueid: r.uniqueid ?? r.Uniqueid,
      ruleId: r.ruleId ?? r.RuleId,
      maloaitb: r.maloaitb ?? r.Maloaitb,
      tenLoaiTb: r.tenLoaiTb ?? r.TenLoaiTb,
      makcb: r.makcb ?? r.Makcb,
      manv: r.manv ?? r.Manv,
      makk: r.makk ?? r.Makk,
      mamucdo: r.mamucdo ?? r.Mamucdo,
      tenMucDo: r.tenMucDo ?? r.TenMucDo,
      colorCode: r.colorCode ?? r.ColorCode,
      noidung: r.noidung ?? r.Noidung,
      ngay: r.ngay ?? r.Ngay,
      systemtime: r.systemtime ?? r.Systemtime,
      active: r.active ?? r.Active,
      tendichvu: r.tendichvu ?? r.Tendichvu,
      manhom: r.manhom != null ? Number(r.manhom) : (r.Manhom != null ? Number(r.Manhom) : null),
      ngaykt: r.ngaykt ?? r.Ngaykt
    }));
  },

  async runByLoaiTb(request: RunRulesByLoaiTbRequestDto): Promise<RunRulesByLoaiTbResponseDto> {
    const res = await api.post('/notifications/run-by-loaitb', request);
    return {
      success: res.data.success ?? res.data.Success ?? false,
      rulesCount: res.data.rulesCount ?? res.data.RulesCount ?? 0,
      totalRowsReturned: res.data.totalRowsReturned ?? res.data.TotalRowsReturned ?? 0,
      totalNotificationsInserted: res.data.totalNotificationsInserted ?? res.data.TotalNotificationsInserted ?? 0,
      message: res.data.message ?? res.data.Message ?? ''
    };
  },

  async getNhanVienForFilter(): Promise<FilterOption[]> {
    const res = await api.get('/notifications/filter/nhanvien');
    return (res.data || []).map((r: any) => ({
      value: r.value ?? r.Value,
      label: r.label ?? r.Label
    }));
  },

  async getKhoaPhongForFilter(): Promise<FilterOption[]> {
    const res = await api.get('/notifications/filter/khoaphong');
    return (res.data || []).map((r: any) => ({
      value: r.value ?? r.Value,
      label: r.label ?? r.Label
    }));
  },

  async getTenDichVuForFilter(): Promise<FilterOption[]> {
    const res = await api.get('/notifications/filter/tendichvu');
    return (res.data || []).map((r: any) => ({
      value: r.value ?? r.Value,
      label: r.label ?? r.Label
    }));
  },

  async deleteAll(): Promise<{ success: boolean; message: string; deletedCount: number }> {
    const res = await api.delete('/notifications/delete-all');
    return {
      success: res.data.success ?? res.data.Success ?? false,
      message: res.data.message ?? res.data.Message ?? '',
      deletedCount: res.data.deletedCount ?? res.data.DeletedCount ?? 0
    };
  }
};
